import BrandAvatar from '@medflex/components/stories/BrandAvatar';
import Link from '@medflex/components/stories/Link';
import * as React from 'react';
import { useTranslation } from 'react-i18next';

const FailedProfileLoadError = () => {
  const { t } = useTranslation('global', { keyPrefix: 'FailedProfileLoadError' });
  return (
    <div className="flex flex-col justify-center items-center h-full">
      <BrandAvatar size="16" className="mb-2" />
      <h1 className="mb-2 text-2xl">{t('title')}</h1>
      <p className="mb-4">{t('text')}</p>
      <Link kind="button:primary" href={window.location.href}>
        {t('refresh_button')}
      </Link>
    </div>
  );
};

export default FailedProfileLoadError;
